/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProductForRestaurantQueryVariables = Exact<{
  baseProductSlug: string;
  restaurantId: string;
}>;

export type ProductForRestaurantQuery = {
  readonly productForRestaurant: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
  } | null;
};

export const ProductForRestaurantDocument = gql`
  query ProductForRestaurant($baseProductSlug: String!, $restaurantId: String!) {
    productForRestaurant(baseProductSlug: $baseProductSlug, restaurantId: $restaurantId) {
      id
      __typename
      slug
    }
  }
`;

export function useProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ProductForRestaurantQuery, ProductForRestaurantQueryVariables>({
    query: ProductForRestaurantDocument,
    ...options,
  });
}
